import React from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from '../../components/section-title/SectionTitle';
import useInspectorSections from './hooks/useInspectorSections';

import scss from './InspectorPanel.module.scss';

function InspectorPanel({ isEmbedded = false }) {
  const { t } = useTranslation('mediaStudio');
  const sections = useInspectorSections();

  if (!sections.length) {
    return null;
  }

  if (isEmbedded) {
    return <div className={scss.embedded}>{sections}</div>;
  }

  return (
    <aside className={scss.panel}>
      <SectionTitle title={t('inspector')} className={scss.title} />
      {sections}
    </aside>
  );
}

export default InspectorPanel;
